import { Col, Row } from "antd";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo-white.png";
import Container from "../../components/container/Container";
import Description from "../../components/typography/description/Description";
import Title from "../../components/typography/title/Title";
import SocialIcons from "../../components/socialIcons/SocialIcons";
import PaymentIcons from "../../components/paymentIcons/PaymentIcons";
import { UserContext } from "../../context/UserContext";
import { blogUrl } from "../../config/config";

const Footer = () => {
  const { userData } = useContext(UserContext);
  const isLoggedIn = Boolean(userData?.email);

  const menues = [
    {
      title: "Account",
      data: [
        { link: "/accounts", label: "My Account" },
        { link: "/", label: "Order History" },
        { link: "/signup", label: "Sign Up" },
        { link: "/login", label: "Login" },
      ],
    },
    {
      title: "Services",
      data: [
        // { link: "/", label: "Discount Returns" },
        { link: "/policy", label: "Policy" },
        { link: "/solution", label: "Solution" },
        { link: "/agreement", label: "Terms & Conditions" },
      ],
    },
    {
      title: "Info",
      data: [
        { link: "/about", label: "About Us" },
        { link: blogUrl, label: "Blog", external: true },
        { link: "/explore", label: "Explore" },
        { link: "/story", label: "Story" },
        { link: "/passion", label: "Passion" },
      ],
    },
  ];

  const socialLinks = [
    "https://www.facebook.com/theinkox/",
    "https://www.instagram.com/inkoxprints/",
    "https://twitter.com/?lang=en",
    "https://pk.linkedin.com/",
    "https://www.youtube.com/@InkoxOfficial/",
  ];

  return (
    <footer className="footer-main">
      <Container>
        <Row gutter={[40, 28]}>
          <Col xs={24} md={12}>
            <Row gutter={[32, 24]}>
              <Col xs={24} md={12}>
                <Link to={"/"} className="footer-logo">
                  <img src={logo} alt="logo" />
                </Link>
       
                <SocialIcons data={socialLinks} />
              </Col>
              <Col xs={24} md={10}>
                <Title
                  customClass={"contact-title"}
                  tag={"h3"}
                  size={"17"}
                  weight={600}
                >
                  Contact Us
                </Title>
                <Description customClass="footer-contact-text">
                Have questions or need assistance? We're here to help! Reach out to us and we'll get back to you as soon as possible.
                </Description>
                <a className="footer-phone-link" href="tel:+01000011111111">+01 0000 1111 1111</a>

              </Col>
            </Row>
          </Col>
          <Col xs={24} md={12}>
            <Row justify={"space-between"} gutter={[32, 24]}>
              {menues?.map((item1, index) => {
                return (
                  <Col xs={12} md={7} key={index}>
                    <Title customClass="footer-heading" tag={"h3"} size={"17"} weight={600}>
                      {item1.title}
                    </Title>
                    <ul className="footer-links">
                      {item1.data?.map((item2, i) => {
                        const isAuthLink = item2.link === "/signup" || item2.link === "/login";
                        const isDisabled = isAuthLink && isLoggedIn;

                        return (
                          <li key={i}>
                            {isDisabled ? (
                              <span className="footer-link-disabled" aria-disabled="true">
                                {item2.label}
                              </span>
                            ) : (
                              item2.external ? (
                                <a href={item2.link}>{item2.label}</a>
                              ) : (
                                <Link to={item2.link}>{item2.label}</Link>
                              )
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </Container>
      <div className="copyright">
        <Container>
          <Row gutter={[20, 20]} align={"middle"}>
            <Col xs={24} md={12}>
              <Title customClass="footer-copyright-text" tag={"h3"} size={"14"} weight={400}>
              &copy; 2025 Inkofly.com. All rights reserved.
              </Title>
            </Col>
            <Col xs={24} md={12}>
              <PaymentIcons />
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
